import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '../images/up.png';
import _imports_1 from '../images/eco_line.png';
var _hoisted_1 = {
  class: "article container"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "art_headlines"
}, "Disease Areas", -1);

var _hoisted_3 = {
  class: "art_content"
};

var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "art_title_point"
}, null, -1);

var _hoisted_5 = {
  class: "art_title_text"
};
var _hoisted_6 = {
  class: "big_title_art"
};
var _hoisted_7 = {
  key: 0,
  class: ""
};
var _hoisted_8 = ["onClick"];

var _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1);

var _hoisted_10 = {
  class: ""
};
var _hoisted_11 = {
  class: "art_left_img col-lg-4 col-md-4 col-sm-12 col-xs-12"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  class: "art_left_i_title"
};
var _hoisted_14 = {
  key: 0,
  class: ""
};
var _hoisted_15 = {
  class: "art_right_contet col-lg-8 col-md-8 col-sm-12 col-xs-12"
};
var _hoisted_16 = {
  class: "art_r_t"
};
var _hoisted_17 = {
  key: 0,
  class: ""
};
var _hoisted_18 = ["innerHTML"];
var _hoisted_19 = {
  class: "art_close"
};

var _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "art_close_icon_line"
}, null, -1);

var _hoisted_21 = [_hoisted_20];

var _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "art_line"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_collapse_item = _resolveComponent("el-collapse-item");

  var _component_el_collapse = _resolveComponent("el-collapse");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_collapse, {
    accordion: false,
    modelValue: $setup.activeNames,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $setup.activeNames = $event;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fieldList, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "",
          key: index
        }, [_createElementVNode("div", null, [_createElementVNode("div", {
          class: _normalizeClass([$setup.activeNames != index ? 'art_title_box' : 'art_title_none'])
        }, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(item.title) + " ", 1), item.subTitle ? (_openBlock(), _createElementBlock("span", _hoisted_7, "（" + _toDisplayString(item.subTitle) + "）", 1)) : _createCommentVNode("", true)])]), _createElementVNode("img", {
          src: _imports_0,
          class: "art_up_icon",
          onClick: function onClick($event) {
            return $setup.toggleMore(index);
          }
        }, null, 8, _hoisted_8)], 2), _createVNode(_component_el_collapse_item, {
          class: "Consistency",
          name: index
        }, {
          title: _withCtx(function () {
            return [_hoisted_9];
          }),
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
              src: item.imageUrl,
              class: "art_l_img"
            }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, [_createTextVNode(_toDisplayString(item.title) + " ", 1), item.subTitle ? (_openBlock(), _createElementBlock("span", _hoisted_14, "（" + _toDisplayString(item.subTitle) + "）", 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createTextVNode(_toDisplayString(item.title) + " ", 1), item.subTitle ? (_openBlock(), _createElementBlock("span", _hoisted_17, "（" + _toDisplayString(item.subTitle) + "）", 1)) : _createCommentVNode("", true)]), _createElementVNode("div", {
              class: "art_r_c",
              innerHTML: item.content
            }, null, 8, _hoisted_18), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
              class: "art_close_icon",
              onClick: _cache[0] || (_cache[0] = function () {
                return $setup.retract && $setup.retract.apply($setup, arguments);
              })
            }, _hoisted_21)])])])];
          }),
          _: 2
        }, 1032, ["name"])]), _hoisted_22]);
      }), 128))])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}